import { Box, Button, Divider, FormControlLabel, Popover, Stack, Switch } from "@mui/material";
import useLocalStorage from "../../../minimals/hooks/useLocalStorage";
import { useEffect } from "react";

const columnSwitches = [
  { label: "Category", key: "category" },
  { label: "Quick Note", key: "quickNote" },
  { label: "Responsible Party", key: "responsibleParty" },
  { label: "Status", key: "status" }
];

export default function HideColumns({
  open,
  handleClose,
  anchorEl
}: {
  open: boolean;
  handleClose: () => void;
  anchorEl: HTMLButtonElement | null;
}) {
  const [hiddenColumns, setHiddenColumns] = useLocalStorage<string[]>("hiddenColumns", []);

  const toggle = (key: string, checked: boolean) => {
    setHiddenColumns((prev: string[]) => {
      const updated = checked ? prev.filter((v) => v !== key) : [...prev, key];
      return updated;
    });
  };

  useEffect(() => {
    window.dispatchEvent(new Event("hiddenColumnsUpdated"));
  }, [hiddenColumns]);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <Box sx={{ p: 2 }}>
        <Stack direction="column">
          {columnSwitches.map(({ label, key }) => (
            <FormControlLabel
              key={key}
              control={
                <Switch checked={!hiddenColumns.includes(key)} onChange={(e, checked) => toggle(key, checked)} />
              }
              label={label}
            />
          ))}
        </Stack>
      </Box>
    </Popover>
  );
}
